import React from 'react';
import { Reveal } from './Reveal';
export function Guarantee() {
  return <section className="w-full bg-surface px-4 py-20 sm:py-24" data-id="element-102" data-mp="1o3ne23a6eqyf">
      <Reveal className="mx-auto max-w-2xl rounded-2xl border border-amber/50 bg-mist p-9 text-center shadow-premium sm:p-12" data-id="element-103" data-mp="1o33smclbhkfn">
        <div className="text-5xl" data-id="element-104" data-mp="22126lgvq7eum">🛡️</div>
        <h2 className="mt-5 font-serif text-4xl leading-tight text-navy sm:text-5xl" style={{
        fontSize: "20px"
      }} data-id="element-105" data-mp="1x5d4b5sbnjum">
          7-Day Digital Purchase Protection
        </h2>
        <p className="mt-6 text-sm leading-7 text-slate sm:text-base" data-id="element-106" data-mp="14fxs4cox7kx4">
          Purchase with confidence.
        </p>
        <p className="mt-4 text-sm leading-7 text-slate sm:text-base" data-id="element-107" data-mp="1j4ty847f2nv3">
          Your purchase is protected for 7 days in case of a duplicate charge, an access problem
          we’re unable to resolve, or if the digital product materially differs from what is
          described on this page.
        </p>
        <p className="mt-4 text-sm leading-7 text-slate sm:text-base" data-id="element-108" data-mp="lo50alll85qz">
          Because this is instant-access digital content, change-of-mind refunds are not available
          once the files have been accessed or downloaded, except where required by applicable
          consumer law.
        </p>
        <p className="mt-7 font-semibold text-sage" data-id="element-109" data-mp="yqdyjqkzcebn">
          ✓ Instant Digital Delivery · ✓ Secure Payment · ✓ Customer Support · ✓ 7-Day Purchase
          Protection
        </p>
      </Reveal>
    </section>;
}